import PropTypes from "prop-types";
import React from "react";

import {ResearchPropType} from "../prop-types";
import {ResearchTemplate} from "../templates/research-template";


export const Research = (props) => {
  const {
    className,
    totalResearches,
  } = props;

  const researchTemplate = new ResearchTemplate(totalResearches).getTemplate();

  return (
    <React.Fragment>
      <div className={className} dangerouslySetInnerHTML={{__html: researchTemplate}}></div>
    </React.Fragment>
  );
};


Research.propTypes = {
  className: PropTypes.string.isRequired,
  totalResearches: PropTypes.arrayOf(ResearchPropType).isRequired,
};
